import { render, staticRenderFns } from "./POrder.vue?vue&type=template&id=720bea2a&scoped=true&"
import script from "./POrder.vue?vue&type=script&lang=js&"
export * from "./POrder.vue?vue&type=script&lang=js&"
import style0 from "./POrder.vue?vue&type=style&index=0&id=720bea2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720bea2a",
  null
  
)

export default component.exports